export default __webpack_public_path__ + "static/media/verified.3898b17b.svg";